import React, { useState, useEffect } from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { AccidentType, Country } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useLanguage } from "../../../../contexts";

const accidentTypeController = new AccidentType();
const countryController = new Country();

export function AccidentTypeForm({ accidentType, close, onReload }) {
  const { accessToken } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const [countryOptions, setCountryOptions] = useState([]);

  useEffect(() => {
    countryController.getCountries(accessToken, true).then((countries) => {
      setCountryOptions(countries.map((c) => ({ key: c._id, value: c.code, text: c.name })));
    }).catch(() => {});
  }, [accessToken]);

  const formik = useFormik({
    initialValues: {
      code:    accidentType?.code    || "",
      name:    accidentType?.name    || "",
      country: accidentType?.country || "",
    },
    validationSchema: Yup.object({
      code: Yup.string().required(t("code_required") !== "code_required" ? t("code_required") : "El código es requerido"),
      name: Yup.string().required(t("name_required") !== "name_required" ? t("name_required") : "El nombre es requerido"),
    }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (accidentType) {
          await accidentTypeController.updateAccidentType(accessToken, accidentType._id, values);
          toast.success(t("updated"));
        } else {
          await accidentTypeController.createAccidentType(accessToken, values);
          toast.success(t("created"));
        }
        onReload(); close();
      } catch (err) {
        toast.error(err?.msg || t("error"));
      } finally {
        setSubmitting(false);
      }
    },
  });

  const allCountriesOption = { key: "", value: "", text: t("all_countries") };

  return (
    <Form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />
      <Form.Input
        label={<label>{t("code")} <span style={{ color: "#C0392B" }}>*</span></label>}
        name="code"
        value={formik.values.code}
        onChange={(e) => {
          const v = e.target.value;
          formik.setFieldValue("code", v.length > 0 ? v.charAt(0).toUpperCase() + v.slice(1).toLowerCase() : v);
        }}
        error={formik.errors.code}
        placeholder="Ej: MC"
        autoFocus
      />
      <Form.Input
        label={<label>{t("name")} <span style={{ color: "#C0392B" }}>*</span></label>}
        name="name"
        value={formik.values.name}
        onChange={(e) => {
          const v = e.target.value;
          formik.setFieldValue("name", v ? v.charAt(0).toUpperCase() + v.slice(1) : v);
        }}
        error={formik.errors.name}
        placeholder="Ej: Caída de altura"
      />
      <Form.Select
        label={<label>{t("country")}</label>}
        name="country"
        value={formik.values.country}
        options={[allCountriesOption, ...countryOptions]}
        onChange={(_, { value }) => formik.setFieldValue("country", value)}
        placeholder={t("all_countries")}
        search
      />
      <div style={{ display: "flex", justifyContent: "center", gap: "14px", marginTop: "2rem" }}>
        <button type="submit" disabled={formik.isSubmitting} style={{ background: "#4A7FA5", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer", opacity: formik.isSubmitting ? 0.55 : 1 }}>
          {formik.isSubmitting ? "…" : (accidentType ? t("update") : t("save"))}
        </button>
        <button type="button" onClick={close} style={{ background: "#9BAFC4", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer" }}>
          {t("cancel")}
        </button>
      </div>
    </Form>
  );
}
